import { createContext } from "react";
import { SharedCurrentUser } from "./types";

export const CurrentUserContext = createContext<SharedCurrentUser>(undefined);
